module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAPZJREFUWIXtl2EOgyAMhdtl97I72fBksJN1PzaWrrZaEZcs4SUkpsrrB6IFgKFGMTMxc363iBIzU9jcSVhbNKkJIn3RSJQA4A4AMyImFfNUNsakB3RDRLuPIM1GTCqHp/TlkSzvFoBdiZX359XV2HWvCSLeWpJ7uvQ0GwADYAAMgH8AoMMAoh4k535mR+KxeSuBLkYR07pn2JTsYxWjGQAmRamJScKtFKiiA92K2cosLErumo4swiKSkgNpxnsBeAvpscek12fo7RfpVwBSU72om9rTpL4u4u+NZ2gRHgVw/w+RBXgmRIr2XxxMGiFqwuIeOIYcPQH0nuU9Njg/zwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_like@2x2.png
// module id = Gw/i
// module chunks = 1